import React from 'react';
import { Box, ListItemIcon, Menu, MenuItem } from '@mui/material';
import './menu.m.css';

function MenuDropDown({ open, handleClose, anchorEl, selectedItem, kebabMenuItem, branchTab = false, data = {} }) {
  return (
    <div className='menudropdown-wrapper'>
      {kebabMenuItem.length > 0 && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          sx={{
            boxShadow: '0px 0px 0px transparent',
            mt: '1px',
            '& .MuiMenu-paper': { paddingRight: '0px' }
          }}
          onClose={handleClose}
          MenuListProps={{
            disablePadding: true
          }}
        >
          {kebabMenuItem.map((val, index) => {
            let showButton = val?.hasPermission === undefined ? true : val?.hasPermission;
            if (showButton) {
              if (val.changeTitle) {
                let statusIndex = val.status.findIndex(status => status === selectedItem.status);
                return (
                  <MenuItem
                    key={`${val.title[statusIndex]}-${index}`}
                    onClick={() => {
                      val.onClick(selectedItem);
                      handleClose();
                    }}
                  >
                    <ListItemIcon>
                      <val.icon fontSize={val.fontSize} />
                    </ListItemIcon>
                    {val.title[statusIndex]}
                  </MenuItem>
                );
              } else {
                if (branchTab) {
                  console.log(branchTab);
                  return (
                    <MenuItem
                      key={`${val.title}-${index}`}
                      onClick={() => {
                        val.onClick(selectedItem);
                        handleClose();
                      }}
                      disabled={data?.defaultBranch || false}
                    >
                      {!val?.removeIcon && (
                        <ListItemIcon>
                          <val.icon fontSize={val.fontSize} />
                        </ListItemIcon>
                      )}

                      <Box sx={{ color: val?.titleColor ? val?.titleColor : '#0A0909' }}>{val.title}</Box>
                    </MenuItem>
                  );
                } else {
                  return (
                    <MenuItem
                      key={`${val.title}-${index}`}
                      onClick={() => {
                        val.onClick(selectedItem);
                        handleClose();
                      }}
                    >
                      {!val?.removeIcon && (
                        <ListItemIcon>
                          <val.icon fontSize={val.fontSize} />
                        </ListItemIcon>
                      )}

                      <Box sx={{ color: val?.titleColor ? val?.titleColor : '#0A0909' }}>{val.title}</Box>
                    </MenuItem>
                  );
                }
              }
            }
            return null;
          })}
        </Menu>
      )}
    </div>
  );
}

export default MenuDropDown;
